import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'
import BlockOneImg from "../../assets/images/modal/school_design_1.png"
import BlockTwoImg from "../../assets/images/modal/school_design_2.png"
import BlockThreeImg from "../../assets/images/modal/school_design_3.png"
import BlockFourImg from "../../assets/images/modal/school_design_4.png"
import BlockFiveImg from "../../assets/images/modal/school_design_pants.png"
import BlockSixImg from "../../assets/images/modal/school_design_hat.png"
import BlockSevenImg from "../../assets/images/modal/school_design_bag.png"
import BlockEightImg from "../../assets/images/modal/school_design_crossbag.png"

export const designOptionsStaticContent = (
  <div className="static-wrapper">
    <div className="cards-wrapper">
      <div className="small-double-vertical-card">
        <img src={BlockOneImg} alt="design 1"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockOne.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockOne.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockTwoImg} alt="design 2"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockTwo.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockTwo.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockThreeImg} alt="design 3"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockThree.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockThree.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockFourImg} alt="design 4"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockFour.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockFour.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockFiveImg} alt="sdesign 5"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockFive.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockFive.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockSixImg} alt="design 6"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockSix.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockSix.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockSevenImg } alt="design 7"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockSeven.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockSeven.text"}/></p>
        </div>
      </div>
      <div className="small-double-vertical-card">
        <img src={BlockEightImg} alt="design 8"/>
        <div>
          <h3><FormattedMessage id={"ModalFour.blockEight.title"}/></h3>
          <p><FormattedMessage id={"ModalFour.blockEight.text"}/></p>
        </div>
      </div>
    </div>
  </div>
)
